<template>
    <div>
        <stage-status-modal-edit :daddy-name="name" :modal-name="modalName" />

        <div class="area-toogle">
            <div v-show="loader.body" class="loading-card">
                <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="40" :stroke="8" />
            </div>

            <transition name="fade">
                <div v-show="!loader.body" class="content">
                    <draggable
                        v-model="stageList"
                        v-bind="dragOptions"
                        group="stage"
                        draggable=".drag-stage"
                        @start="startDragStage"
                        @end="endDragStage"
                    >
                        <div
                            v-for="(stage, i) in stageList"
                            :key="`${i}-${stage.id}`"
                            class="drag-stage"
                        >
                            <stage-card
                                :object-data="stage"
                                :title="`#${i + 1} - ${stage.name}`"
                                :entry="
                                    stage.privacy == 'public' || stage.privacy == 'public_private'
                                "
                                :exit="
                                    stage.privacy == 'public' || stage.privacy == 'private_public'
                                "
                                sortable
                                @stage-card-edit="editStage"
                            >
                                <div v-show="stage.status.length > 0" class="title-status">
                                    Status desta Etapa:
                                </div>

                                <draggable
                                    v-model="stage.status"
                                    v-bind="dragOptions"
                                    :group="`status-${stage.id}`"
                                    class="loop-status"
                                    draggable=".drag-status"
                                    @start="startDragStatus"
                                    @end="endDragStatus(stage.id)"
                                >
                                    <transition-group
                                        type="transition"
                                        :name="!drag.status ? 'flip-list' : null"
                                    >
                                        <div
                                            v-for="status in stage.status"
                                            :key="status.id"
                                            class="drag-status item-s"
                                        >
                                            <status-card
                                                :object-data="{ stage: stage, status: status }"
                                                :title="status.name"
                                                :entry="
                                                    status.privacy == 'public' ||
                                                        status.privacy == 'public_private'
                                                "
                                                :exit="
                                                    status.privacy == 'public' ||
                                                        status.privacy == 'private_public'
                                                "
                                                reset-css
                                                sortable
                                                @status-card-edit="editStatus"
                                            />
                                        </div>
                                    </transition-group>
                                </draggable>

                                <div v-if="!$mx_userIsCollaborator" class="add-button-area mt-3">
                                    <div class="add">
                                        <ui-button design="md primary" @click="createStatus(stage)"
                                        ><i class="fal fa-plus"/></ui-button>
                                    </div>
                                    <div class="desc">
                                        Clique para <span> adicionar </span> um novo Status.
                                    </div>
                                </div>
                            </stage-card>
                        </div>
                    </draggable>

                    <div class="add-button-area mt-4">
                        <div class="add">
                            <ui-button design="lg primary" @click="createStage"
                            ><i class="fal fa-plus"/></ui-button>
                        </div>
                        <div class="desc">Clique para <span> adicionar </span> uma nova Etapa.</div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
	import StageCard from './components/stage-card'
	import StageStatusModalEdit from './components/stage-status-modal-edit'
	import StatusCard from './components/status-card'

	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'
	import { uiUtilInputButton } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'

	import { utilMixin, alertMixin, permissionsMixin } from '@/mixins'

	import { funnel } from '@/services/axios'

	import draggable from 'vuedraggable'

	const defaultRequest = () => ({
		stages: [],
	})

	const defaultDrag = () => ({
		dragStage: false,
		dragStatus: false,
	})

	const defaultLoader = () => ({
		body: false,
	})

	export default {
		name: 'ui-stage-status-config',

		components: {
			draggable,
			StageCard,
			StageStatusModalEdit,
			StatusCard,
			uiUtilInputButton,
			uiButton,
			uiInput,
			uiLoadIndicator,
		},

		mixins: [utilMixin, alertMixin, permissionsMixin],

		data() {
			return {
				name: 'stage-status-config',
				drag: { ...defaultDrag() },
				request: { ...defaultRequest() },
				loader: { ...defaultLoader() },
				stageList: [],
				oldStageList: null,
				oldStatusPositions: null,
			}
		},

		computed: {
			modalName() {
				return this.name + '-stage-modal'
			},

			stagesPosition() {
				const positions = []
				this.stageList.forEach((stage, index) => {
					positions.push({
						position: index,
						id: stage.id,
					})
				})
				return positions
			},

			stagesStatusPositions() {
				const positions = []
				this.stageList.forEach((stage, index) => {
					const actualStage = {
						position: index,
						id: stage.id,
						statusPostions: [],
					}

					stage.status.forEach((status, i) => {
						actualStage.statusPostions.push({
							id: status.id,
							position: i,
						})
					})

					positions.push(actualStage)
				})
				return positions
			},

			dragOptions() {
				return {
					animation: 200,
					group: 'description',
					disabled: false,
					ghostClass: 'ghost',
				}
			},

			isStageListChanged() {
				return this.$mx_isChanged(this.stageList, this.oldStageList)
			},
		},

		async created() {
			this.loader.body = true

			this.$root.$on(`${this.name}:update`, async () => {
				await this.syncFunnel()
			})

			await this.syncFunnel()
			this.loader.body = false
		},

		destroyed() {
			this.$root.$off(`${this.name}:update`)
		},

		methods: {
			async syncFunnel() {
				try {
					this.request.stages = (await funnel.getStages()).data
					this.stageList = this.request.stages
				} catch (err) {
					this.$mx_alertThisOnError(err)
				}
			},

			startDragStage() {
				this.drag.stage = true
				this.oldStageList = this.$mx_copyObject(this.stageList)
			},

			async endDragStage() {
				this.drag.stage = false
				if (this.isStageListChanged) {
					try {
						await funnel.reorder({
							data: [...this.stagesPosition],
						})
					} catch (err) {
						this.$mx_alertThisOnError(err)
					}
				}
			},

			startDragStatus() {
				this.drag.status = true
				this.oldStageList = this.$mx_copyObject(this.stageList)
			},

			async endDragStatus(stageId) {
				this.drag.status = false
				if (this.isStageListChanged) {
					const sts = this.stagesStatusPositions.find((stage) => stage.id == stageId)
					try {
						await funnel.reorder(
							{
								data: [...sts.statusPostions],
							},
							'status',
						)
					} catch (err) {
						this.$mx_alertThisOnError(err)
					}
				}
			},

			createStage() {
				const payload = { type: 'stage', edit: false }
				this.$root.$emit('modal-open-' + this.modalName, payload)
			},

			createStatus(stage) {
				if (this.$mx_userIsCollaborator) return
				
				const payload = { type: 'status', edit: false, stage: stage }
				this.$root.$emit('modal-open-' + this.modalName, payload)
			},

			editStage(payload) {
				payload.type = 'stage'
				payload.edit = true
				this.$root.$emit('modal-open-' + this.modalName, payload)
			},

			editStatus(payload) {
				payload.type = 'status'
				payload.edit = true
				this.$root.$emit('modal-open-' + this.modalName, payload)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
